import MoonIcon from 'assets/darkTheme/icon-moon.svg';
import ArrowHeadIcon from 'assets/darkTheme/icon-arrowhead.svg';
import SearchIcon from 'assets/darkTheme/icon-search.svg';
import ArrowIcon from 'assets/darkTheme/icon-arrow.svg';
import NoResultsIcon from 'assets/darkTheme/icon-no-results.svg';

export const darkTheme = {
  elementBgColor: 'hsl(209, 23%, 22%)',
  bgColor: 'hsl(207, 26%, 17%)',
  shadowColor: 'hsl(0, 0%, 10%)',
  fontColor: {
    primary: 'hsl(0, 0%, 100%)',
    secondary: 'hsl(0, 0%, 90%)',
    tertiary: 'hsl(0, 0%, 80%)'
  },
  icons: {
    moon: MoonIcon,
    arrowHead: ArrowHeadIcon,
    search: SearchIcon,
    arrow: ArrowIcon,
    noResults: NoResultsIcon
  }
};
